import Vue from 'vue';
import moment from 'moment';

const pickerDateFormat = 'YYYY-M-D';
const uiDateFormat = 'DD/MM/YYYY';

export default {
  name: 'EmployeeSchedule',
  components: {
    TimeComp: require('../../components/time.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appData: { employee: { fullname: '' }, stations: [] },
      showDate: { periodDate: false, periodBegin: false, periodEnd: false },
      periodDate: {},
      periodBegin: {},
      periodEnd: {},
      stationId: -1,
      allEmployees: [],
      timeBegin: { hours: 0, minutes: 0, descr: 'employeeSchedule.PeriodTimeBegin', isReadOnly: false },
      timeEnd: { hours: 0, minutes: 0, descr: 'employeeSchedule.PeriodTimeEnd', isReadOnly: false },
    }
  },
  computed: {
    employee: function () {
      return this.appData.employee;
    },
    formattedPeriodBegin: function () {
      return this.formatDateUI(moment(this.periodBegin));
    },
    formattedPeriodEnd: function () {
      return this.formatDateUI(moment(this.periodEnd));
    },
    timeBeginHours: function () {
      return this.timeBegin.hours;
    },
    timeBeginMinutes: function () {
      return this.timeBegin.minutes;
    },
    timeEndHours: function () {
      return this.timeEnd.hours;
    },
    timeEndMinutes: function () {
      return this.timeEnd.minutes;
    },
  },
  watch: {
    stationId: function (value) {
      this.appData.employees = (this.stationId === -1) ? this.allEmployees : this.allEmployees.filter(item => item.stationId == this.stationId);
    },
    employee: function (value) {
      if (value && value.employeeId && this.$refs.select)
        this.$refs.select.open = false;
    },
    timeBeginHours: function (value) {
      this.appData.periodBeginHH = value;
    },
    timeBeginMinutes: function (value) {
      this.appData.periodBeginMin = value;
    },
    timeEndHours: function (value) {
      this.appData.periodEndHH = value;
    },
    timeEndMinutes: function (value) {
      this.appData.periodEndMin = value;
    }
  },
  created() {
    this.init();
    this.$root.$on('employee_schedule_updated', this.init);
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appData = this.dataObj;
        this.allEmployees = this.appData.employees;
        //this.periodDate = moment(this.appData.periodDate).subtract(1, 'days').format();
        this.periodBegin = moment(this.appData.periodBegin).subtract(1, 'days').format();
        this.periodEnd = moment(this.appData.periodEnd).subtract(1, 'days').format();
        this.timeBegin.hours = this.appData.periodBeginHH;
        this.timeBegin.minutes = this.appData.periodBeginMin;
        this.timeEnd.hours = this.appData.periodEndHH;
        this.timeEnd.minutes = this.appData.periodEndMin;
      });
    },
  },
}

